import { ICellRendererParams } from 'ag-grid-community';
import { UserStatus } from 'api/models';
import { Member, User } from 'data/members/api';
import { fullName } from 'utils/full-name';
import { sortByText } from 'utils/sort-by-text';
import { PermissionMap } from '../use-permission';

interface Data {
  data: Member;
}
type WithData<AgGridType> = Pick<
  AgGridType,
  Exclude<keyof AgGridType, 'data'>
> &
  Data;

export type MemberCellRendererParams = WithData<ICellRendererParams>;

export const setDeactivedRowStyle = (params: WithData<ICellRendererParams>) =>
  params.data?.user?.userStatus === UserStatus.Inactive && { opacity: '0.4' };

export const memberNameSorter = (prevUser: User, nextUser: User): number =>
  sortByText(fullName(prevUser), fullName(nextUser));

export const permissionSorter = (
  permissionSetA: Member['permissionSet'],
  permissionSetB: Member['permissionSet'],
  translate,
): number => {
  const permissionNameKeyA = PermissionMap[permissionSetA?.permissionSetType];
  const permissionNameKeyB = PermissionMap[permissionSetB?.permissionSetType];
  const permissionNameA =
    permissionNameKeyA != null
      ? translate(`permissions.${permissionNameKeyA}`)
      : null;
  const permissionNameB =
    permissionNameKeyB != null
      ? translate(`permissions.${permissionNameKeyB}`)
      : null;

  return sortByText(permissionNameA, permissionNameB);
};
